import React, { ReactNode } from "react";
import styles from "./index.module.scss";

interface FormCardProps {
  title: ReactNode;
  children: ReactNode;
}

const FormCard: React.FC<FormCardProps> = ({ title, children }) => {
  return (
    <div className={styles.formCard}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.cardContent}>{children}</div>
    </div>
  );
};

export default FormCard;
